import { IpaginatedSeccionmarketings, ISeccionmarketingsItem } from '../models'

export enum SeccionmarketingsActionTypes {
  SEARCH_SECCIONMARKETINGS = 'seccionmarketings/search',
  SEARCHING_SECCIONMARKETINGS = 'seccionmarketings/searching',
  FOUND_SECCIONMARKETINGS = 'seccionmarketings/found',
  SEARCHING_SECCIONMARKETINGS_FAILED = 'seccionmarketings/searching_failed',

  LOAD_SECCIONMARKETINGS = 'seccionmarketings/load',
  LOADING_SECCIONMARKETINGS = 'seccionmarketings/loading',
  LOADED_SECCIONMARKETINGS = 'seccionmarketings/loaded',
  LOADING_SECCIONMARKETINGS_FAILED = 'seccionmarketings/loading_failed',

  ADD_SECCIONMARKETINGS = 'seccionmarketings/add',
  ADDING_SECCIONMARKETINGS = 'seccionmarketings/adding',
  ADDED_SECCIONMARKETINGS = 'seccionmarketings/added',
  ADDING_SECCIONMARKETINGS_FAILED = 'seccionmarketings/adding_failed',

  REMOVE_SECCIONMARKETING = 'seccionmarketings/remove',
  REMOVING_SECCIONMARKETING = 'seccionmarketings/removing',
  REMOVED_SECCIONMARKETING = 'seccionmarketings/removed',
  REMOVING_SECCIONMARKETING_FAILED = 'seccionmarketings/removing_failed',

  SOFT_REMOVE_SECCIONMARKETINGS = 'seccionmarketings/soft_remove',
  SOFT_REMOVING_SECCIONMARKETINGS = 'seccionmarketings/soft_removing',
  SOFT_REMOVED_SECCIONMARKETINGS = 'seccionmarketings/soft_removed',
  SOFT_REMOVING_SECCIONMARKETINGS_FAILED = 'seccionmarketings/soft_removing_failed',

  EDIT_SECCIONMARKETINGS = 'seccionmarketings/edit',
  EDITING_SECCIONMARKETINGS = 'seccionmarketings/editing',
  EDITED_SECCIONMARKETINGS = 'seccionmarketings/edited',
  EDITING_SECCIONMARKETINGS_FAILED = 'seccionmarketings/editing_failed',

  VIEW_SECCIONMARKETINGS = 'seccionmarketings/view',
  VIEWING_SECCIONMARKETINGS = 'seccionmarketings/viewing',
  VIEWED_SECCIONMARKETINGS = 'seccionmarketings/viewed',
  VIEWING_SECCIONMARKETINGS_FAILED = 'seccionmarketings/viewing_failed',
}

export function searchSeccionmarketings(searchOptions: TSearchOptions | string, keep?: boolean): ISearchSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.SEARCH_SECCIONMARKETINGS,
    searchOptions: typeof searchOptions === 'string' ? { searchString: searchOptions } : searchOptions,
    keep: keep,
  }
}

export function searchingSeccionmarketings(): ISearchingSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.SEARCHING_SECCIONMARKETINGS,
  }
}

export function foundSeccionmarketings(seccionmarketings: IpaginatedSeccionmarketings, keep?: boolean): IFoundSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.FOUND_SECCIONMARKETINGS,
    keep: keep,
    payload: {
      seccionmarketings,
    },
  }
}

export function searchingSeccionmarketingsFailed(): ISearchingSeccionmarketingsFailedAction {
  return {
    type: SeccionmarketingsActionTypes.SEARCHING_SECCIONMARKETINGS_FAILED,
  }
}

export function loadSeccionmarketings(loadOptions: TSearchOptions): ILoadSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.LOAD_SECCIONMARKETINGS,
    loadOptions: loadOptions,
  }
}

export function loadingSeccionmarketings(): ILoadingSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.LOADING_SECCIONMARKETINGS,
  }
}

export function loadedSeccionmarketings(seccionmarketings: IpaginatedSeccionmarketings): ILoadedSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.LOADED_SECCIONMARKETINGS,
    payload: {
      seccionmarketings,
    },
  }
}

export function loadingSeccionmarketingsFailed(): ILoadingSeccionmarketingsFailedAction {
  return {
    type: SeccionmarketingsActionTypes.LOADING_SECCIONMARKETINGS_FAILED,
  }
}

export function addSeccionmarketings(seccionmarketing: ISeccionmarketingsItem): IAddSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.ADD_SECCIONMARKETINGS,
    payload: seccionmarketing,
  }
}

export function addingSeccionmarketings(): IAddingSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.ADDING_SECCIONMARKETINGS,
  }
}

export function addedSeccionmarketings(seccionmarketings: IpaginatedSeccionmarketings): IAddedSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.ADDED_SECCIONMARKETINGS,
    payload: {
      seccionmarketings,
    },
  }
}

export function addingSeccionmarketingsFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IAddingSeccionmarketingsFailedAction {
  return {
    type: SeccionmarketingsActionTypes.ADDING_SECCIONMARKETINGS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function removeSeccionmarketing(seccionmarketing: ISeccionmarketingsItem): IRemoveSeccionmarketingAction {
  return {
    type: SeccionmarketingsActionTypes.REMOVE_SECCIONMARKETING,
    payload: seccionmarketing,
  }
}

export function removingSeccionmarketing(): IRemovingSeccionmarketingAction {
  return {
    type: SeccionmarketingsActionTypes.REMOVING_SECCIONMARKETING,
  }
}

export function removedSeccionmarketing(): IRemovedSeccionmarketingAction {
  return {
    type: SeccionmarketingsActionTypes.REMOVED_SECCIONMARKETING,
  }
}

export function removingSeccionmarketingFailed(): IRemovingSeccionmarketingFailedAction {
  return {
    type: SeccionmarketingsActionTypes.REMOVING_SECCIONMARKETING_FAILED,
  }
}

export function softRemoveSeccionmarketings(seccionmarketing: ISeccionmarketingsItem): ISoftRemoveSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.SOFT_REMOVE_SECCIONMARKETINGS,
    payload: seccionmarketing,
  }
}

export function softRemovingSeccionmarketings(): ISoftRemovingSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.SOFT_REMOVING_SECCIONMARKETINGS,
  }
}

export function softRemovedSeccionmarketings(seccionmarketing: ISeccionmarketingsItem): ISoftRemovedSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.SOFT_REMOVED_SECCIONMARKETINGS,
    payload: seccionmarketing,
  }
}

export function softRemovingSeccionmarketingsFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): ISoftRemovingSeccionmarketingsFailedAction {
  return {
    type: SeccionmarketingsActionTypes.SOFT_REMOVING_SECCIONMARKETINGS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function editSeccionmarketings(seccionmarketing: ISeccionmarketingsItem): IEditSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.EDIT_SECCIONMARKETINGS,
    payload: seccionmarketing,
  }
}

export function editingSeccionmarketings(): IEditingSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.EDITING_SECCIONMARKETINGS,
  }
}

export function editedSeccionmarketings(seccionmarketings: ISeccionmarketingsItem): IEditedSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.EDITED_SECCIONMARKETINGS,
    payload: seccionmarketings,
  }
}

export function editingSeccionmarketingsFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IEditingSeccionmarketingsFailedAction {
  return {
    type: SeccionmarketingsActionTypes.EDITING_SECCIONMARKETINGS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function viewSeccionmarketings(seccionmarketing: ISeccionmarketingsItem): IViewSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.VIEW_SECCIONMARKETINGS,
    payload: seccionmarketing,
  }
}

export function viewingSeccionmarketings(): IViewingSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.VIEWING_SECCIONMARKETINGS,
  }
}

export function viewedSeccionmarketings(seccionmarketings: ISeccionmarketingsItem): IViewedSeccionmarketingsAction {
  return {
    type: SeccionmarketingsActionTypes.VIEWED_SECCIONMARKETINGS,
    payload: seccionmarketings,
  }
}

export function viewingSeccionmarketingsFailed(): IViewingSeccionmarketingsFailedAction {
  return {
    type: SeccionmarketingsActionTypes.VIEWING_SECCIONMARKETINGS_FAILED,
  }
}

type TSearchOptions = {
  searchString?: string
  searchField?: string
  page?: number
  limit?: number
  populate?: boolean
  sort?: {
    field: string
    method?: 'asc' | 'desc'
  }
  filters?: { field: string; value: string }[]
}

export interface ISearchSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.SEARCH_SECCIONMARKETINGS
  searchOptions: TSearchOptions
  keep?: boolean
}

export interface ISearchingSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.SEARCHING_SECCIONMARKETINGS
}

export interface IFoundSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.FOUND_SECCIONMARKETINGS
  keep?: boolean
  payload: {
    seccionmarketings: IpaginatedSeccionmarketings
  }
}

export interface ISearchingSeccionmarketingsFailedAction {
  type: SeccionmarketingsActionTypes.SEARCHING_SECCIONMARKETINGS_FAILED
}

export interface ILoadSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.LOAD_SECCIONMARKETINGS
  loadOptions: TSearchOptions
}

export interface ILoadingSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.LOADING_SECCIONMARKETINGS
}

export interface ILoadedSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.LOADED_SECCIONMARKETINGS
  payload: {
    seccionmarketings: IpaginatedSeccionmarketings
  }
}

export interface ILoadingSeccionmarketingsFailedAction {
  type: SeccionmarketingsActionTypes.LOADING_SECCIONMARKETINGS_FAILED
}

export interface IAddSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.ADD_SECCIONMARKETINGS
  payload: ISeccionmarketingsItem
}

export interface IAddingSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.ADDING_SECCIONMARKETINGS
}

export interface IAddedSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.ADDED_SECCIONMARKETINGS
  payload: {
    seccionmarketings: IpaginatedSeccionmarketings
  }
}

export interface IAddingSeccionmarketingsFailedAction {
  type: SeccionmarketingsActionTypes.ADDING_SECCIONMARKETINGS_FAILED
  message: string
  status: number
  field?: string
}

export interface IRemoveSeccionmarketingAction {
  type: SeccionmarketingsActionTypes.REMOVE_SECCIONMARKETING
  payload: ISeccionmarketingsItem
}

export interface IRemovingSeccionmarketingAction {
  type: SeccionmarketingsActionTypes.REMOVING_SECCIONMARKETING
}

export interface IRemovedSeccionmarketingAction {
  type: SeccionmarketingsActionTypes.REMOVED_SECCIONMARKETING
}

export interface IRemovingSeccionmarketingFailedAction {
  type: SeccionmarketingsActionTypes.REMOVING_SECCIONMARKETING_FAILED
}

export interface ISoftRemoveSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.SOFT_REMOVE_SECCIONMARKETINGS
  payload: ISeccionmarketingsItem
}

export interface ISoftRemovingSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.SOFT_REMOVING_SECCIONMARKETINGS
}

export interface ISoftRemovedSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.SOFT_REMOVED_SECCIONMARKETINGS
  payload: ISeccionmarketingsItem
}

export interface ISoftRemovingSeccionmarketingsFailedAction {
  type: SeccionmarketingsActionTypes.SOFT_REMOVING_SECCIONMARKETINGS_FAILED
  message: string
  status: number
  field?: string
}

export interface IEditSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.EDIT_SECCIONMARKETINGS
  payload: ISeccionmarketingsItem
}

export interface IEditingSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.EDITING_SECCIONMARKETINGS
}

export interface IEditedSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.EDITED_SECCIONMARKETINGS
  payload: ISeccionmarketingsItem
}

export interface IEditingSeccionmarketingsFailedAction {
  type: SeccionmarketingsActionTypes.EDITING_SECCIONMARKETINGS_FAILED
  message: string
  status: number
  field?: string
}

export interface IViewSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.VIEW_SECCIONMARKETINGS
  payload: ISeccionmarketingsItem
}

export interface IViewingSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.VIEWING_SECCIONMARKETINGS
}

export interface IViewedSeccionmarketingsAction {
  type: SeccionmarketingsActionTypes.VIEWED_SECCIONMARKETINGS
  payload: ISeccionmarketingsItem
}

export interface IViewingSeccionmarketingsFailedAction {
  type: SeccionmarketingsActionTypes.VIEWING_SECCIONMARKETINGS_FAILED
}

export type SeccionmarketingsAction =
  | ISearchSeccionmarketingsAction
  | ISearchingSeccionmarketingsAction
  | IFoundSeccionmarketingsAction
  | ISearchingSeccionmarketingsFailedAction
  | ILoadSeccionmarketingsAction
  | ILoadingSeccionmarketingsAction
  | ILoadedSeccionmarketingsAction
  | ILoadingSeccionmarketingsFailedAction
  | IAddSeccionmarketingsAction
  | IAddingSeccionmarketingsAction
  | IAddedSeccionmarketingsAction
  | IAddingSeccionmarketingsFailedAction
  | IRemoveSeccionmarketingAction
  | IRemovingSeccionmarketingAction
  | IRemovedSeccionmarketingAction
  | IRemovingSeccionmarketingFailedAction
  | ISoftRemoveSeccionmarketingsAction
  | ISoftRemovingSeccionmarketingsAction
  | ISoftRemovedSeccionmarketingsAction
  | ISoftRemovingSeccionmarketingsFailedAction
  | IEditSeccionmarketingsAction
  | IEditingSeccionmarketingsAction
  | IEditedSeccionmarketingsAction
  | IEditingSeccionmarketingsFailedAction
  | IViewSeccionmarketingsAction
  | IViewingSeccionmarketingsAction
  | IViewedSeccionmarketingsAction
  | IViewingSeccionmarketingsFailedAction
